import React, {setState, useRef, useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import styles from "./Invoices.module.css";
import { useHistory } from 'react-router-dom'
import moment from 'moment'
import PropTypes from 'prop-types';
import { makeStyles, useTheme, alpha } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container'
import { Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import { useSnackbar } from 'react-simple-snackbar'
import {DataGrid, GridToolbar, GridCellEditStopReasons, GridComparatorFn, DEFAULT_GRID_AUTOSIZE_OPTIONS} from "@mui/x-data-grid";
import axios from 'axios';
import ProgressButton from 'react-progress-button'
import { deleteInvoice, getInvoicesByUser } from '../../actions/invoiceActions';
import { getAccountsByUser } from '../../actions/accountActions';
import { useLocation } from 'react-router-dom';
import useAuthUser from '../../hooks/useAuthUser'
import { formatDollarsToCents, formatCentsToDollars, displayAsDollars, displayFromDollars } from '../../utils/money'

import NoData from '../svgIcons/NoData';
import Spinner from '../Spinner/Spinner'


import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { getVisibleRows } from '@mui/x-data-grid/internals';

const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    marginLeft: theme.spacing(2.5),

  },
}));

const useStyles2 = makeStyles(theme => ({
  table: {
    minWidth: 500,
    
  },

  tablecell: {
    fontSize: '16px'
}
}));

const tableStyle = { width: 160, fontSize: 14, cursor: 'pointer', borderBottom: 'none',  padding: '8px', textAlign: 'center' }
const headerStyle = { borderBottom: 'none', textAlign: 'center'}
const SEND_FLOW = [
  { eventType: 'pc_pdf', label: 'Sent to PC' },
  { eventType: 'customer_pdf', label: 'Sent to Customer' },
  { eventType: 'proof_of_delivery', label: 'Sent Proof of Delivery' },
]

const getStatementDueDateTime = (row) => {
  if (!row?.dueDate) return Number.POSITIVE_INFINITY;
  const dueDateTime = new Date(row.dueDate).getTime();
  return Number.isNaN(dueDateTime) ? Number.POSITIVE_INFINITY : dueDateTime;
};


const Invoices = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const history = useHistory()
  const {invoices} = useSelector(state => state.invoices);
  const { profiles } = useSelector(state => state.profiles || {});
  const { accounts = [] } = useSelector(state => state.accounts || {});
  const authData = useAuthUser()
  const [rows, setRows] = useState(invoices);
  const [todayRows, setTodayRows] = useState([]);
  const isLoading = useSelector(state => state.invoices.isLoading)
        // eslint-disable-next-line 
  const [openSnackbar, closeSnackbar] = useSnackbar()
  const [selectedDate, setSelectedDate] = useState(null);
  const [downloadStatus, setDownloadStatus] = useState('disabled')
  const [downloadTdStatus, setDownloadTdStatus] = useState('')
  const [downloadStatementStatus, setDownloadStatementStatus] = useState('disabled')
  const [sendStatementStatus, setSendStatementStatus] = useState('disabled')
  const profileDetail = React.useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('profileDetail') || '{}');
    } catch {
      return {};
    }
  }, []);
  const warehouseEmailList = profiles?.emailWarehouseList || profileDetail?.emailWarehouseList || '';
  const statuses = ['Unpaid', 'Paid', 'Partial']
  const clientArray = [...new Set(invoices.map(invoice => {
    if (invoice.client.store) {
      return invoice.client.store
    }
  }))].sort()




  // const rows = []


    // useEffect(() => {
    //     dispatch(getInvoices());
    // }, [dispatch]);

    useEffect(() => {
        const searchId = authData?.result?._id || authData?.result?.googleId
        if (searchId) {
          dispatch(getInvoicesByUser({search: searchId}));
          dispatch(getAccountsByUser({ search: searchId }));
        }
      // eslint-disable-next-line
    },[location, authData])

    useEffect(() => {
      let today = new Date();
      let todayM = moment(today).format('MM/DD/yyyy')
      const todayRows = invoices.filter((row) => {
        if (moment(row.receivedByDate).format('MM/DD/yyyy').includes(todayM)) {
          return true;
        }
        return false;
      });
      setTodayRows(todayRows);
      setRows(invoices)
    }, [invoices])

   const toCommas = (value) => {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    }

  const classes = useStyles2();
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rows.length);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  // const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  // const handleChangePage = (event, newPage) => {
  //   setPage(newPage);
  // };

  // const handleChangeRowsPerPage = (event) => {
  //   setRowsPerPage(parseInt(event.target.value, 10));
  //   setPage(0);
  // };

  // const handleDateChange = (value) => {
  //   if (value !== null) {
  //     let val = moment(value).format('MM/DD/yyyy');
  //     setSelectedDate(val);
  //     const filteredRows = invoices.filter((row) => {
  //       if (moment(row.receivedByDate).format('MM/DD/yyyy').includes(val)) {
  //         return true;
  //       }
  //       return false;
  //     });
  //     if (filteredRows.length > 0) {
  //       setDownloadStatus('')
  //     }
  //     setRows(filteredRows);
  //   } else {
  //     //setDownloadStatus('disabled')
  //     setRows(invoices);
  //   }
  // }


  // Print Invoices
  const printInvoices = async () => {
    if (rows.length > 0) {
      console.log(rows)
      setDownloadStatus('loading')
      let pdfList = rows.map(row => {
        //Get the total amount paid
        let totalAmountReceived = 0
        for(var i = 0; i < row?.paymentRecords?.length; i++) {
            totalAmountReceived += Number(row?.paymentRecords[i]?.amountPaid)
        }
        return { name: row.client.name,
          store: row.client.store,
          address: row.client.address,
          phone: row.client.cellPhone,
          email: row.client.email,
          dueDate: row.dueDate,
          receivedByDate: row.receivedByDate,
          date: row.createdAt,
          id: row.rowNumber,
          notes: row.notes,
          subTotal: toCommas(row.subTotal),
          total: toCommas(row.total),
          type: row.type,
          salesTax: row.salesTax,
          deliveryFee: row.deliveryFee,
          items: row.items,
          status: row.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(row.total - totalAmountReceived),
          paymentRecords: row.paymentRecords,
      }
      })
      axios.post(`${process.env.REACT_APP_API}/pdfs/create-pdf-landscape`, 
      { pdfDate : '', pdfList }
      , {responseType: 'blob'})
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(pdfBlob);
          //Open the URL on new Window
           const pdfWindow = window.open();
           pdfWindow.location.href = fileURL;  
          // saveAs(pdfBlob, 'invoice.pdf')
        }).then(() =>  setDownloadStatus('success'))
    } else {
      setDownloadStatus('error')
    }
   }

   // Print Invoices
  const printTdInvoices = async () => {
    if (todayRows.length > 0) {
      setDownloadTdStatus('loading')
      let pdfList = todayRows.map(row => {
        //Get the total amount paid
        let totalAmountReceived = 0
        for(var i = 0; i < row?.paymentRecords?.length; i++) {
            totalAmountReceived += Number(row?.paymentRecords[i]?.amountPaid)
        }
        return { name: row.client.name,
          store: row.client.store,
          address: row.client.address,
          phone: row.client.cellPhone,
          email: row.client.email,
          dueDate: row.dueDate,
          receivedByDate: row.receivedByDate,
          date: row.createdAt,
          id: row.rowNumber,
          notes: row.notes,
          subTotal: toCommas(row.subTotal),
          total: toCommas(row.total),
          type: row.type,
          salesTax: row.salesTax,
          deliveryFee: row.deliveryFee,
          items: row.items,
          status: row.status,
          totalAmountReceived: toCommas(totalAmountReceived),
          balanceDue: toCommas(row.total - totalAmountReceived),
          paymentRecords: row.paymentRecords,
      }
      })
      axios.post(`${process.env.REACT_APP_API}/pdfs/create-pdf-landscape`, 
      { pdfDate : '', pdfList }
      , {responseType: 'blob'})
        .then((res) => {
          const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(pdfBlob);
          //Open the URL on new Window
           const pdfWindow = window.open();
           pdfWindow.location.href = fileURL;  
          // saveAs(pdfBlob, 'invoice.pdf')
        }).then(() =>  setDownloadTdStatus('success'))
    } else {
      setDownloadTdStatus('error')
    }
  }

  const [selectedClientFilter, setSelectedClientFilter] = useState('');

  const statementRows = React.useMemo(() => (
    invoices
      .filter((row) => {
        if (!selectedClientFilter) return false;
        return row?.client?.store === selectedClientFilter && (row?.status === 'Unpaid' || row?.status === 'Partial');
      })
      .sort((a, b) => getStatementDueDateTime(a) - getStatementDueDateTime(b))
  ), [invoices, selectedClientFilter]);

  const statementClient = React.useMemo(() => {
    if (!statementRows.length) return null;
    const row = statementRows[0] || {};
    const client = row?.client || {};
    const accountId = row?.billTo?.accountId || client?.accountId;
    const accountMatch =
      accounts.find((acc) => acc?._id === accountId) ||
      accounts.find((acc) => acc?.name === selectedClientFilter);
    const emailFromAccount = accountMatch?.email || '';
    const emailFromClient = client.email || client?.emailAddress || '';
    return { ...client, email: emailFromAccount || emailFromClient };
  }, [accounts, selectedClientFilter, statementRows]);

  useEffect(() => {
    const enabled = statementRows.length ? '' : 'disabled';
    setDownloadStatementStatus(enabled);
    setSendStatementStatus(enabled);
  }, [statementRows.length]);

  const downloadStatement = async () => {
    if (!selectedClientFilter || statementRows.length === 0) {
      setDownloadStatementStatus('error');
      return;
    }
    const client = statementClient;
    if (!client?.email) {
      setDownloadStatementStatus('error');
      return;
    }
    setDownloadStatementStatus('loading');
    const pdfList = statementRows.map((row) => {
      let totalAmountReceived = 0;
      for (var i = 0; i < row?.paymentRecords?.length; i++) {
        totalAmountReceived += Number(row?.paymentRecords[i]?.amountPaid);
      }
      return {
        name: row.client.name,
        store: row.client.store,
        address: row.client.address,
        phone: row.client.cellPhone,
        email: row.client.email,
        dueDate: row.dueDate,
        receivedByDate: row.receivedByDate,
        date: row.createdAt,
        rowNumber: row.rowNumber,
        invoiceNumber: row.invoiceNumber,
        clientPONumber: row.clientPONumber,
        notes: row.notes,
        subTotal: Number(row.subTotal || 0),
        total: Number(row.total || 0),
        type: row.type,
        salesTax: Number(row.salesTax || 0),
        deliveryFee: Number(row.deliveryFee || 0),
        items: row.items,
        status: row.status,
        totalAmountReceived,
        balanceDue: Number(row.total || 0) - totalAmountReceived,
        paymentRecords: row.paymentRecords,
      };
    });

    axios
      .post(
        `${process.env.REACT_APP_API}/pdfs/create-statement`,
        { client, invoices: pdfList },
        { responseType: 'blob' }
      )
      .then((res) => {
        const pdfBlob = new Blob([res.data], { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(pdfBlob);
        const pdfWindow = window.open();
        pdfWindow.location.href = fileURL;
      })
      .then(() => setDownloadStatementStatus('success'))
      .catch(() => setDownloadStatementStatus('error'));
  };

  const sendStatement = async () => {
    if (!selectedClientFilter || statementRows.length === 0) {
      setSendStatementStatus('error');
      return;
    }
    const client = statementClient;
    const recipientEmail = client?.email || '';
    if (!recipientEmail) {
      setSendStatementStatus('error');
      return;
    }
    setSendStatementStatus('loading');
    const payload = {
      client,
      invoices: statementRows.map((row) => {
        let totalAmountReceived = 0;
        for (var i = 0; i < row?.paymentRecords?.length; i++) {
          totalAmountReceived += Number(row?.paymentRecords[i]?.amountPaid);
        }
        return {
          name: row.client.name,
          store: row.client.store,
          address: row.client.address,
          phone: row.client.cellPhone,
          email: row.client.email,
          dueDate: row.dueDate,
          receivedByDate: row.receivedByDate,
          date: row.createdAt,
          rowNumber: row.rowNumber,
          invoiceNumber: row.invoiceNumber,
          clientPONumber: row.clientPONumber,
          notes: row.notes,
          subTotal: Number(row.subTotal || 0),
          total: Number(row.total || 0),
          type: row.type,
          salesTax: Number(row.salesTax || 0),
          deliveryFee: Number(row.deliveryFee || 0),
          items: row.items,
          status: row.status,
          totalAmountReceived,
          balanceDue: Number(row.total || 0) - totalAmountReceived,
          paymentRecords: row.paymentRecords,
        };
      }),
      email: recipientEmail,
      bccList: warehouseEmailList,
    };

    axios
      .post(`${process.env.REACT_APP_API}/pdfs/send-statement`, payload)
      .then(() => setSendStatementStatus('success'))
      .catch(() => setSendStatementStatus('error'));
  };


  const riskyInvoiceIds = React.useMemo(() => {
    const riskySet = new Set();
    const resolvedSet = new Set();
    (invoices || []).forEach(inv => {
      const hasRiskyItem = (inv?.items || []).some(item => {
        const unitCost = parseFloat(item?.unitCost) || 0;
        const unitPrice = parseFloat(item?.unitPrice) || 0;
        return unitCost > unitPrice;
      });
      if (hasRiskyItem) {
        const id = String(inv?._id || '');
        if (!id) return;
        if (inv?.flaggedResolved) resolvedSet.add(id);
        else riskySet.add(id);
      }
    });
    return { riskySet, resolvedSet };
  }, [invoices]);

  const columns = [
    {
      field: 'invoiceNumber',
      headerName: 'Invoice #',
      editable: false,
      minWidth: 120,
      flex: 0.6,
    },
    {
      field: 'client',
      headerName: 'Client',
       type: 'singleSelect',
      valueOptions: clientArray,
      editable: false,
      minWidth: 125,
      flex: 1,
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        const valueFormatted = params.value.store;
        return valueFormatted;
      }, 
    },
    {
      field: 'clientPONumber',
      headerName: 'Client PO #',
      editable: false,
      minWidth: 140,
      flex: 0.9,
      valueGetter: (params) => params.value || '—',
    },
    { 
      field: 'total', 
      headerName: 'Amount', 
      editable: false,
      flex: 1,
      minWidth: 100,
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        return displayFromDollars(params.value);
      },
    },
    { 
      flex: 1,
      minWidth: 150,
      field: 'receivedByDate', 
      headerName: 'Received Date',
      editable: false,
      type: 'date',
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        // const valueFormatted = moment(params.value).format('MM/DD/yyyy');
        // return valueFormatted;
        const valueFormatted = new Date(params.value);
        return valueFormatted;
      },
    },
    { 
      flex: 1,
      minWidth: 150,
      field: 'dueDate', 
      headerName: 'Due Date', 
      editable: false,
      type: 'date',
      valueGetter: (params) => {
        if (!params.value) {
          return params.value;
        }
        // const valueFormatted = moment(params.value).format('MM/DD/yyyy');
        // return valueFormatted;
        const valueFormatted = new Date(params.value);
        return valueFormatted;
      },
    },
    { field: 'status',
      type: 'singleSelect',
      valueOptions: statuses,
       headerName: 'Status',
       width: 165,
       renderCell: (params) => {
      const history = Array.isArray(params?.row?.sendHistory) ? params.row.sendHistory : [];
      const sentTypes = new Set(
        history
          .map((entry) => entry?.eventType)
          .filter(Boolean)
      );
      return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
          <button style={checkStatus(params.value)}>{params.value}</button>
          <div style={{ display: 'flex', gap: 6, lineHeight: 1 }}>
            {SEND_FLOW.map((step) => {
              const sent = sentTypes.has(step.eventType);
              return (
                <span
                  key={step.eventType}
                  title={step.label}
                  style={{
                    fontSize: 14,
                    fontWeight: 700,
                    color: sent ? '#15803d' : '#64748b',
                    width: 12,
                    textAlign: 'center',
                    userSelect: 'none',
                  }}
                >
                  {sent ? '✓' : '•'}
                </span>
              );
            })}
          </div>
        </div>
      );
    } },
    { field: 'actions', headerName: 'Actions', headerAlign: 'center', align: 'center', flex:1, minWidth: 200, renderCell: (params) => {
      return (
        <div style={{display: 'flex'}}>
          <Button
            style={{color: 'white', backgroundColor: 'rgb(25, 118, 210)', marginRight: 10}}
            onClick={() => editInvoice(params.row._id)}
            variant="contained"
          >
            Edit
          </Button>
          <Button
            style={{color: 'white', backgroundColor: 'red'}}
            onClick={(e) => {
              e.stopPropagation();
              setDeleteTargetId(params.row._id);
            }}
            variant="contained"
          >
            Delete
          </Button>
            
  
        </div>
        
      );
    } }
  ];

  const editInvoice = (id) => {
    history.push(`/edit/invoice/${id}`)
  }

  const openInvoice = (id) => {
    history.push(`/invoice/${id}`)
  }

  const handleCancelDelete = () => setDeleteTargetId(null);
  const handleConfirmDelete = () => {
    if (deleteTargetId) {
      dispatch(deleteInvoice(deleteTargetId, openSnackbar));
    }
    setDeleteTargetId(null);
  };

  if(!authData) {
    history.push('/login')
  }



  function checkStatus(status) {
    return status === "Partial" ? {border: 'solid 0px #1976d2', backgroundColor: '#baddff', padding: '8px 18px', borderRadius: '20px' }
        : status === "Paid" ? {border: 'solid 0px green', backgroundColor: '#a5ffcd', padding: '8px 18px', borderRadius: '20px' }
        : status === "Unpaid" ? {border: 'solid 0px red', backgroundColor: '#ffaa91', padding: '8px 18px', borderRadius: '20px' }
        : "red";
          
}

  if(isLoading) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px'}}>
        <Spinner />
    </div>
  }

  if(rows.length === 0 && invoices.length === 0) {
    return  <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', paddingTop: '20px', margin: '80px'}}>
      <NoData />
    <p style={{padding: '40px', color: 'gray', textAlign: 'center'}}>No invoice yet. Click the plus icon to create invoice</p>
  
    </div>
  }
  
  return (
    <div className={styles.pageLayout}>
      <Dialog open={Boolean(deleteTargetId)} onClose={handleCancelDelete}>
        <DialogTitle>Delete Invoice</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this invoice? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary" variant="contained">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
      <Container style={{maxWidth: 1600}}>
        <div className={styles.buttons}>
        <h1 style={{paddingTop: 10}}>Invoices</h1>
          <ProgressButton 
            style={{width: 100}}
            onClick={printInvoices} 
            state={downloadStatus}>
            Print All
          </ProgressButton>
          <ProgressButton 
            style={{width: 100}}
            onClick={printTdInvoices} 
            state={downloadTdStatus}>
            Print Today
          </ProgressButton>
          <ProgressButton
            style={{width: 140}}
            onClick={downloadStatement}
            state={downloadStatementStatus}
            disabled={!selectedClientFilter}
          >
            Download Statement
          </ProgressButton>
          <ProgressButton
            style={{width: 140}}
            onClick={sendStatement}
            state={sendStatementStatus}
            disabled={!selectedClientFilter}
          >
            Send Statement
          </ProgressButton>
        </div>
        <p className={styles.statementHint}>To download statement select client</p>
        <div className={styles.gridLayout}>
              <DataGrid
              sx={{
                '&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell': { py: '6px' },
                '&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell': { py: '8px' },
                '&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell': { py: '12px' },
              }}
                autoHeight
                rows={invoices}
                getRowId={(row) => row._id}
                getRowHeight={() => 'auto'}
                columns={columns}
                pageSize={20}
                components={{
                  Toolbar: GridToolbar,
                }}
                onRowClick={(row) => openInvoice(row.id)}
                onFilterModelChange={(e) => {
                  console.log(e)
                    if ((e.items[0].value !== undefined && e.items[0].value !== '') && e.items[0].field === 'receivedByDate') {
                    setDownloadStatus('')
                  } else {
                    setDownloadStatus('disabled')
                  }
                  const filteredRows = invoices.filter((row) => {
                        if (moment(row.receivedByDate).format('MM/DD/yyyy').includes(selectedDate)) {
                          return true;
                        }
                        return false;
                      });
                      setRows(filteredRows);
                  
                }}
                onStateChange={(e) => {
                  if (e.filter.filterModel.items.length > 0) {
                    const activeFilter = e.filter.filterModel.items[0];
                    if (activeFilter.field === 'receivedByDate' && (activeFilter.value !== "" && activeFilter.value !== undefined)) {
                      let temp = moment(activeFilter.value).format('MM/DD/yyyy')
                      setSelectedDate(temp)
                    } else {
                      let today = new Date();
                      let val = moment(today).format('MM/DD/yyyy');
                      setSelectedDate(val)
                    }
                    if (activeFilter.field === 'client' && activeFilter.value) {
                      setSelectedClientFilter(activeFilter.value);
                    } else {
                      setSelectedClientFilter('');
                    }
                  } else {
                      let today = new Date();
                      let val = moment(today).format('MM/DD/yyyy');
                      setSelectedDate(val)
                      setSelectedClientFilter('');
                    }
                }}
                sortingOrder={['desc','asc']}
                initialState={{
                  sorting: {
                    sortModel: [
                      {
                        field: 'receivedByDate',
                        sort: 'desc'
                      }
                    ]
                  }
                }}
                getRowClassName={(params) => {
                  const rowId = String(params.id || '');
                  if (riskyInvoiceIds.resolvedSet.has(rowId)) return styles.costWarningResolvedRow;
                  if (riskyInvoiceIds.riskySet.has(rowId)) return styles.costWarningRow;
                  return '';
                }}
              />
          </div>
      </Container>
    </div>
  
  );
}

export default Invoices
